var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Snow',{attrs:{"active":true,"zIndex":"2","wind":-8,"swing":3,"color":"#ffffff"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }